import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Compass, Rocket, GraduationCap, Headphones, CheckCircle, Briefcase, RefreshCw } from 'lucide-react';

const Services = () => {
  const services = [
    { icon: Compass, title: 'Discovery & Solution Design', desc: 'Site walkthroughs, requirement mapping, workflow design, success criteria.' },
    { icon: Rocket, title: 'Deployment & Integration', desc: 'Connect systems, configure rules/workflows, validate in real conditions.' },
    { icon: GraduationCap, title: 'Training & Operational Handover', desc: 'Operator enablement, SOP alignment, adoption support.' },
    { icon: Headphones, title: 'Managed Services & Support', desc: 'Ongoing tuning, updates, performance monitoring, continuous improvement.' }
  ];

  return (
    <div className="min-h-screen">
      <section className="pt-32 pb-20 px-6 bg-gradient-to-b from-[var(--accent-wash)] to-transparent">
        <div className="max-w-6xl mx-auto text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <h1 className="heading-1 mb-6">From discovery to deployment to ongoing optimisation.</h1>
            <p className="body-large text-[var(--text-secondary)] max-w-3xl mx-auto mb-8">
              We don't "drop software." We implement outcomes.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/contact" className="btn-primary">Book a Discovery Call</Link>
              <Link to="/contact" className="btn-secondary">Talk to an Expert</Link>
            </div>
          </motion.div>
        </div>
      </section>

      <section className="py-20 px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="heading-2 text-center mb-12">What you get</h2>
          <div className="grid md:grid-cols-2 gap-8">
            {services.map((service, i) => (
              <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }} className="product-card">
                <service.icon className="w-10 h-10 text-[var(--accent-primary)] mb-4" />
                <h3 className="heading-3 mb-3">{service.title}</h3>
                <p className="text-[var(--text-secondary)]">{service.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 px-6 bg-[var(--bg-section)]">
        <div className="max-w-6xl mx-auto">
          <h2 className="heading-2 text-center mb-12">Engagement options</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <motion.div initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} className="product-card">
              <Briefcase className="w-10 h-10 text-[var(--accent-primary)] mb-4" />
              <h3 className="heading-3 mb-3">Project-based delivery</h3>
              <p className="text-[var(--text-secondary)]">Build and deploy a defined outcome across one or more sites.</p>
            </motion.div>
            <motion.div initial={{ opacity: 0, x: 20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} className="product-card">
              <RefreshCw className="w-10 h-10 text-[var(--accent-primary)] mb-4" />
              <h3 className="heading-3 mb-3">Retainer-based optimisation</h3>
              <p className="text-[var(--text-secondary)]">Keep performance improving—rules tuned, workflows refined, teams supported.</p>
            </motion.div>
          </div>
        </div>
      </section>

      <section className="py-20 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="heading-2 mb-6">If you want intelligence that performs in the real world—start with discovery.</h2>
          <Link to="/contact" className="btn-primary">Book a Discovery Call</Link>
        </div>
      </section>
    </div>
  );
};

export default Services;